import { render, staticRenderFns } from "./AutomationCreated.vue?vue&type=template&id=b66fc86a&scoped=true"
import script from "./AutomationCreated.vue?vue&type=script&lang=js"
export * from "./AutomationCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66fc86a",
  null
  
)

export default component.exports